import gql from 'graphql-tag'

export default gql`query getPressKit {
	getPressKit {
		id
		img_header_desktop
		img_header_mobile
		img_visual_desktop
		img_visual_mobile
		img_push_desktop
		img_push_mobile
		details {
			id
			title
			content
			cta_label
			cta_url
			push_cta_label
			push_cta_url
			language_code
			meta_title
			meta_description
			meta_tags
			meta_og_title
			meta_og_description
			meta_og_url
		}
		updated_at
	}
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/pressKit/get.js